import ExampleStore from '@hkpca-web/stores/ExampleStore'
import InitDataStore from '@hkpca-web/stores/InitDataStore'

export default class RootStore {
  constructor () {
    this.exampleStore = new ExampleStore(this)
    this.initDataStore = new InitDataStore(this)
  }
}
